window.addEventListener('load', () => {
  // Go to top of page on refresh
  if (!window.location.hash) {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }, 0);
  } else {
    // Skip intro video and animations if URL has hash
    document.body.classList.add('is-loaded');
    document.querySelector('.sc-intro-video').remove();
  }
});
